import { render, staticRenderFns } from "./LeadCostsForm.vue?vue&type=template&id=03fdbf10&"
import script from "./LeadCostsForm.vue?vue&type=script&lang=js&"
export * from "./LeadCostsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports